module.exports = __webpack_public_path__ + "assets/img/title-34bfdd91.png";